import { QueryClient } from '@tanstack/react-query';

import formatError, { type FormattedError } from './utils/format-error';

const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 1, // 1 minute
        retry: (failureCount, error) => {
          let formattedError: FormattedError = error as unknown as FormattedError;

          if (!formattedError.isFormatted) {
            formattedError = formatError(error);
          }

          const noRetryStatusCodes = [400, 401, 403, 404];

          if (noRetryStatusCodes.includes(formattedError.statusCode)) {
            return false;
          }

          // Default retry logic: retry up to 3 times for other errors
          return failureCount < 3;
        },
      },
    },
  });

export const queryClient = createQueryClient();
